<template>
  <v-dialog v-model="show" persistent max-width="320" @keydown.esc="$emit('cancel')" @keydown.enter="$emit('accept')">
      <v-card align="center">
      <v-card-title class="text-h5 justify-center">{{getTranslated('_areYouSure')}}</v-card-title>
      <v-card-text>{{text}}</v-card-text>
      <v-card-actions class="justify-center">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="$emit('accept'); loading=true" :loading="loading">{{getTranslated('_accept')}}</v-btn>
          <v-btn color="primary" text @click="$emit('cancel')">{{getTranslated('_cancel')}}</v-btn>
      </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import translationsService from '../services/TranslationsService'

export default {
  name: 'ConfirmationDialog',
  data () {
    return {
      translations: [
        { key: '_cancel', translation: 'Cancel' },
        { key: '_areYouSure', translation: 'Do you want to continue?' },
        { key: '_accept', translation: 'Accept' }
      ],
      loading: false
    }
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Do you want to continue?',
      required: false
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    show: {
      get () {
        return this.showDialog
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    async initialize () {
      await this.getTranslations()
    },
    async getTranslations () {
      if (this.$root.$data.user.profile !== undefined) {
        await translationsService.get('ConfirmationDialog', this.$root.$data.user.profile['customclaim-language']).then(res => {
          this.translations = res.data
        })
      }
    },
    getTranslated (key) {
      var translation = this.translations.filter(element => element.key === key)
      if (translation.length > 0) {
        return translation[0].translation
      } else {
        return 'Translation Error: ' + key
      }
    }
  },
  created () {
    this.initialize()
  },
  watch: {
    show () {
      if (!this.show) {
        this.loading = false
      }
    }
  }
}
</script>
